import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import Calendar from "@/pages/Calendar";
import WhoWeServe from "@/pages/WhoWeServe";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App relative min-h-screen bg-cream-100">
      <div className="grain" aria-hidden="true" />
      <BrowserRouter>
        <SmoothScroll>
          <Navbar />
          <main className="relative z-10">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/products" element={<Products />} />
              <Route path="/calendar" element={<Calendar />} />
              <Route path="/who-we-serve" element={<WhoWeServe />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
        </SmoothScroll>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#2E4A2E",
            color: "#FBF8F0",
            border: "1px solid #C6A24B",
            borderRadius: "4px",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
